import React from "react";

import "./ResetButton.scss";

export default function ResetButton() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
    window.location.reload();
  };
  return (
    <button className="reset-button" onClick={scrollToTop}>
      Reset
    </button>
  );
}
